const skinNoSize = [

    {label:"Site(s)",
    controlType:"text area",
    options:[]
    },
 
    {label:"Description:",
    controlType:"text area",
    options:[]
    },

    {label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
]

export default skinNoSize